export default __webpack_public_path__ + "images/stripe-payment-element/eftpos-500f3e4dce5f69d941cf9ffd30616c24.svg";